/** Cookie Policy. The text is client/public/cookies.html; see StaticLegalPage. */
import StaticLegalPage from './StaticLegalPage';

export default function CookiePolicy() {
  return <StaticLegalPage doc="cookies" />;
}
